import { AbstractControl, UntypedFormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { UserForm } from '@app/user/models/user.form';

export class UserValidator {
  public static requireChange(): ValidatorFn {
    return (form: AbstractControl): ValidationErrors | null => {
      const password = form.get('password') as UntypedFormControl;
      const passwordChangeRequired = form.get('isPasswordChangeRequired') as UntypedFormControl;

      if (passwordChangeRequired.value && (password.pristine || !password.value)) {
        password.setErrors({ required: true });
      }
      return null;
    };
  }

  public static shouldUpdatePasswordIfChanged(): ValidatorFn {
    return (form: AbstractControl): null => {
      const password = form.get('password') as UntypedFormControl;
      const updatePassword = form.get('updatePassword') as UntypedFormControl;

      if (!password.pristine && password.value) {
        updatePassword.setValue(true, {
          emitEvent: false,
          emitModelToViewChange: false,
          emitViewToModelChange: false,
          onlySelf: true,
        });
      }
      return null;
    };
  }

  static requirePasswordRepeated(): ValidatorFn {
    return (form: AbstractControl): ValidationErrors | null => {
      const password = form.get('password') as UntypedFormControl;
      const repeatPassword = form.get('passwordRepeat') as UntypedFormControl;

      if (!password || !repeatPassword) {
        return null;
      }

      if (password.value && password.value !== repeatPassword.value) {
        repeatPassword.setErrors({
          passwordsDifferent: true,
        });
      } else if (repeatPassword && repeatPassword.errors && repeatPassword.errors.passwordsDifferent) {
        repeatPassword.setErrors(null);
      }
      return null;
    };
  }
}
